<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="popupTitle" @close="closePopup" width="500px">
    <el-form slot="content" :ref="formName" :model="domainSettingInfo" :rules="rules" label-position="top">
      <el-row>
        <el-col :span="24">
          <el-form-item label="도메인 이름" prop="domainName">
            <el-input :disabled="isEditableName" v-model="domainSettingInfo.domainName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="트랜잭션 보관주기" prop="txStoreDay">
            <el-input-number style="width:70%" controls-position="right" v-model="domainSettingInfo.txStoreDay" placeholder="입력해 주세요." :min="0"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="large" type="solid" @click="saveDomainInfo">{{saveButtonName}}</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';

export default {
  name: 'WDomainSettingPopup',
  props: {
    popupType: String,
    popupOpenNode: Object,
  },
  data() {
    return {
      popupTitle: '도메인 추가/변경',
      formName: 'domainSettingForm',
      saveButtonName: '저장',
      isEditableName: false,
      domainSettingInfo: {
        domainId: null,
        domainName: null,
        txStoreDay: null,
      },
      rules: {
        domainName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
        txStoreDay: { type: 'number', required: true, trigger: 'blur', message: '숫자값을 입력해주세요' },
      },
    };
  },
  watch: {
    popupOpenNode: {
      handler(node) {
        if (!isNil(node)) {
          if (this.popupType === 'ADD') {
            this.popupTitle = '도메인 추가';
            this.saveButtonName = '저장';
            this.domainSettingInfo.domainName = '';
            this.domainSettingInfo.txStoreDay = null;
          } else {
            this.popupTitle = '도메인 수정';
            this.saveButtonName = '수정';
            this.isEditableName = (this.popupOpenNode.domainId === 1);
            this.domainSettingInfo.domainName = this.popupOpenNode.domainName;
            this.domainSettingInfo.txStoreDay = this.popupOpenNode.txStoreDay;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    saveDomainInfo() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          if (this.popupType === 'ADD') {
            const parmas = {
              domainName: this.domainSettingInfo.domainName,
              txStoreDay: this.domainSettingInfo.txStoreDay,
            };
            ApmSettingAPI.insertApmDomain(parmas).then((response) => {
              if (response.data.success) {
                this.$emit('reload');
                this.closePopup();
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '도메인', response.data.success));
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '도메인', false));
            });
          } else {
            // 도메인 수정 URL 호출
            const params = {
              domainId: this.popupOpenNode.domainId,
              domainName: this.domainSettingInfo.domainName,
              txStoreDay: this.domainSettingInfo.txStoreDay,
            };
            ApmSettingAPI.updateDomain(params).then((response) => {
              if (response.data.success) {
                this.$emit('reload');
                this.closePopup();
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '도메인', response.data.success));
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '도메인', false));
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주세요.'));
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/common/popup/DomainSettingPopup.vue